<app-report-self-inspection-wrapper
  [data]="wrapperData"
  [isLoading$]="isLoading$"
>
  <gc-text>{{ title }}</gc-text>
  <app-radio-button-input
    [data]="data"
    (checkedValue)="handleCheckedValue($event)"
  />
</app-report-self-inspection-wrapper>
